import React from 'react';
import "./Footer.css"


export default function Footer() {
  return (
    <div className="footer" >
    <p>Antonello Napolitano 2022</p>  
    </div>
  );
}